import React from 'react'
import { Modal, Spinner } from '@intellihr/blueberry'
import { PersonDocument, QualificationTemplate } from 'src/__gql__/globalTypes'
import {
  IOnboardingFormSubmitData,
  QualificationInstanceForm,
} from 'src/domain/Compliance/Qualifications/components/Forms/QualificationInstanceForm/QualificationInstanceForm'

interface IQualificationModalProps {
  isModalOpen: boolean
  onClose: () => void
  onSubmit: (formData: IOnboardingFormSubmitData) => void
  submitting: boolean
  qualificationInstance: IQualificationInstanceForModal | null
}

const QualificationsModal: React.FC<IQualificationModalProps> = ({
  isModalOpen,
  onClose,
  onSubmit,
  submitting,
  qualificationInstance,
}) => {
  return (
    <Modal
      testId="qualification-modal"
      subtitle="Qualification"
      variant="content"
      title={qualificationInstance?.qualificationTemplate.name ?? ''}
      open={isModalOpen}
      onOpenChange={onClose}
    >
      {qualificationInstance && (
        <QualificationInstanceForm
          onSubmit={onSubmit}
          submitting={submitting}
          qualificationInstance={qualificationInstance}
          submitButtonAlignment={'right'}
          forOnboarding={true}
        />
      )}
      {!qualificationInstance && <Spinner />}
    </Modal>
  )
}

// Just enough qualification instance data to pass to the modal
export interface IQualificationInstanceForModal {
  id: string
  qualificationStatus: { id: string }
  issuingOrganisation?: string | null
  registrationNumber?: string | null
  issueDate?: string | null
  expiryDate?: string | null
  currentExpiryDate?: string | null
  notes?: string | null
  qualificationTemplate: QualificationTemplate
  attachments: PersonDocument[]
}

export { QualificationsModal }
